import Vue from 'vue'
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

Sentry.init({
  environment: process.env.NODE_ENV,
  dsn: 'https://50427e4aa14747b29e416db3d0609f1d@o322942.ingest.sentry.io/5246522',
  integrations: [new VueIntegration({Vue, attachProps: true})]
})
